import EventModel from '../../../models/Maintenance/Event/EventModel';
import BaseStore from '../../BaseStore';

export default class EventStore extends BaseStore {
	constructor(transportLayer) {
    super(EventModel, transportLayer);
  }
};


// WEBPACK FOOTER //
// ./src/stores/Maintenance/Event/EventStore.js